var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalOpen
        ? _c("SideBarModal", {
            attrs: {
              user: _vm.selectedUser,
              roles: _vm.roles,
              tags: _vm.usersTags,
              onModalClose: () => (this.modalOpen = false),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            !_vm.loading && _vm.originalUsers.length
              ? _c(
                  "tabs",
                  [
                    _c(
                      "tab",
                      { attrs: { title: "Курьеры" } },
                      [
                        _c("RunnersList", {
                          attrs: {
                            users: _vm.runnersData.users,
                            unlinkedUsers: _vm.runnersData.unlinkedUsers,
                            inactiveUsers: _vm.runnersData.inactiveUsers,
                            editUser: _vm.openSideModal,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { title: "Агенты" } },
                      [
                        _c("UsersList", {
                          attrs: {
                            users: _vm.users.agentDivision,
                            editUser: _vm.openSideModal,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { title: "Продажники" } },
                      [
                        _c("ManagersList", {
                          attrs: {
                            users: _vm.users.managers,
                            assists: _vm.users.managerAssist || [],
                            editUser: _vm.openSideModal,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "tab",
                      { attrs: { title: "Прочие сотрудники" } },
                      [
                        _c("UsersList", {
                          attrs: {
                            users: _vm.users.others,
                            editUser: _vm.openSideModal,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loading
              ? _c(
                  "div",
                  [
                    _c("pulse-loader", {
                      staticClass: "text-center",
                      attrs: {
                        loading: true,
                        color: _vm.$constants.LOADING_COLOR,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            false
              ? _c("div", [
                  _vm.users
                    ? _c(
                        "table",
                        {
                          staticClass:
                            "table table-sm table-hover table-striped",
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.users, function (user, index) {
                              return _c("tr", { key: user.id }, [
                                _c("td", [_vm._v(_vm._s(index + 1))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.name))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.login))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.email))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(user.phone))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.printRoles(user)),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-info newWindowBtn mr-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openSideModal(user)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye",
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ФИО")]),
        _vm._v(" "),
        _c("th", [_vm._v("Логин")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Телефон")]),
        _vm._v(" "),
        _c("th", [_vm._v("Должность")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }